import React, { useEffect, useState } from "react";
import { Layout, Menu, Breadcrumb, theme, Dropdown, Avatar } from "antd";
import { useNavigate } from "react-router-dom";
import { LogoutOutlined } from "@ant-design/icons";
import * as Icons from "@ant-design/icons";
import "../styles/Layout.css";

import logo_small from "../assets/mini-logo.png";
import logo_large from "../assets/h-logo.svg";
const { Header, Content, Footer, Sider } = Layout;

const Template = ({ children, breadcrumb = [] }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const navigate = useNavigate();

  const rootSubmenuKeys = menuItems
    .filter((item) => item.children && item.children.length > 0)
    .map((item) => item.label.toLowerCase().replace(/\s+/g, "-"));

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => !openKeys.includes(key));
    if (rootSubmenuKeys.includes(latestOpenKey)) {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    } else {
      setOpenKeys(keys);
    }
  };

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("user"));
    if (!userData) {
      navigate("/login");
      return;
    }

    setMenuItems(userData[0].menu || []);
  }, [navigate]);

  const DynamicAntdIcon = ({ iconName }) => {
    const IconComponent = Icons[iconName];

    if (!IconComponent) {
      return null;
    }

    return <IconComponent />;
  };

  const renderMenu = (items) => {
    return items.map((item) => {
      const { label, url, icon, children } = item;

      const key = label.toLowerCase().replace(/\s+/g, "-");

      if (children && children.length > 0) {
        return {
          key,
          icon: <DynamicAntdIcon iconName={icon} />,
          label,
          children: renderMenu(children),
        };
      }

      return {
        key,
        icon: <DynamicAntdIcon iconName={icon} />,
        label,
        onClick: () => navigate(url),
      };
    });
  };

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const profileMenu = (
    <Menu>
      <Menu.Item
        key="logout"
        icon={<LogoutOutlined />}
        onClick={() => navigate("/logout")}
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  const generateBreadcrumb = () => {
    return breadcrumb.map((item, index) => (
      <Breadcrumb.Item key={index}>
        {index > 0 && <span></span>}
        {item}
      </Breadcrumb.Item>
    ));
  };

  const sessiData = JSON.parse(sessionStorage.getItem("user"));
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
        <div
          className="logo"
          style={{ padding: 20, color: "#fff", textAlign: "center" }}
        >
          {!collapsed ? (
            <img src={logo_large} alt="Logo" style={{ width: "100%" }} />
          ) : (
            <img src={logo_small} alt="Logo" style={{ width: "100%" }} />
          )}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          openKeys={openKeys}
          onOpenChange={onOpenChange}
          selectedKeys={[]}
          items={renderMenu(menuItems)}
        />
      </Sider>
      <Layout>
        <Header
          style={{
            padding: 0,
            background: "#fff",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ marginRight: 10, textAlign: "right", lineHeight: 1 }}>
              <div style={{ fontWeight: "bold", marginBottom: 0 }}>
                {sessiData?.[0]?.user?.[0]?.fullname || "Guest"}
              </div>
              <div
                style={{ fontSize: "12px", color: "#999", marginTop: "5px" }}
              >
                {sessiData?.[0]?.user?.[0]?.jabatan_name || "Unknown Role"}
              </div>
            </div>

            <Dropdown overlay={profileMenu} trigger={["click"]}>
              <div style={{ cursor: "pointer", marginRight: "10px" }}>
                <Avatar
                  size={40}
                  src={
                    sessiData?.[0]?.user?.[0]?.photo || "/default-avatar.png"
                  }
                />
              </div>
            </Dropdown>
          </div>
        </Header>
        <Content style={{ margin: "0 16px" }}>
          <Breadcrumb
            style={{ margin: "16px 0", display: "flex", alignItems: "center" }}
          >
            {generateBreadcrumb()}
          </Breadcrumb>
          <div
            style={{
              padding: 24,
              minHeight: 360,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            {children}
          </div>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          Created by PT.Keberlanjutan Strategis Indonesia ©
          {new Date().getFullYear()}
        </Footer>
      </Layout>
    </Layout>
  );
};

export default Template;
